import FirmIcon from "../../../assets/icon/firmsIcon";
import RingIcon from "../../../assets/icon/ringIcon";
import SecondmentIcon from "../../../assets/icon/secondmentIcon";
import StarIcon from "../../../assets/icon/starIcon";
import { ITabSearchData } from "./navigateTab.props";

export const tabDatas: ITabSearchData[] = [
  {
    id: 0,
    label: "Firms",
    icon: (className?: string) => <FirmIcon className={className} />,
    link: "/search-firms",
    order: 9,
  },
  {
    id: 1,
    label: "Services",
    icon: (className?: string) => <RingIcon className={className} />,
    link: "/search-services",
    order: 1,
  },
  {
    id: 2,
    label: "Products",
    icon: (className?: string) => <StarIcon className={className} />,
    link: "/search-products",
    order: 2,
  },
  // {
  //   id: 3,
  //   label: "Corporate Finance",
  //   icon: (className?: string) => <DolaIcon className={className} />,
  //   link: "",
  //   order: 3,
  // },
  {
    id: 3,
    label: "Secondments",
    icon: (className?: string) => <SecondmentIcon className={className} />,
    link: "/search-secondments",
    order: 3,
  },
];
